import { formatDate } from '../../../utils/helpers';
import _ from 'lodash';

export const filterIaneoCourses = courses => {
  return courses.map(course => ({
    title: {
      en: course.name_de,
      de: course.name_de,
      it: course.name_it,
      fr: course.name_fr,
    },
    location: course.location,
    date: formatDate(course.date),
    id: course.id,
    link: {
      en: course.link_de,
      de: course.link_de,
      it: course.link_it,
      fr: course.link_fr,
    },
  }));
};

export const returnLastSixCourses = courses => {
  return _.orderBy(courses, ['id'], ['desc']).slice(0, 6);
};
